<template>
  <div class="home">   
    <menuBox :step="1"></menuBox>
    <img src="../assets/img-1.png" class="img-1">
    <div class="communication">
      <div class="text-1">通訊</div>
      <div class="text-2">輸入您的電子郵件地址以接收所有新聞、新品</div>
      <div class="text-box">
        <input type="text" name="usrname" class="input-text">
        <div class="subscribe">訂閱</div>
      </div>
    </div>
    <div class="link-box">
      <div class="item">
        <img src="../assets/img-2.png" alt="">
        <div class="item-title">Instagram</div>
        <div class="item-text">
          全球知名社交平台，生動圖片廣告平台，對於有意打造品牌的企業來說，Instagram擁有龐大的用戶和流量，加上精準選擇流量上經驗豐富的廣告系統，是可以挖掘的金子。
        </div>
        <div class="offer-btn">請求報價</div>
      </div>
      <div class="item">
        <img src="../assets/img-3.png" alt="">
        <div class="item-title">Facebook</div>
        <div class="item-text">
          全球精準營銷平台 覆蓋全球，迎合移動趨勢 Facebook在189個國家廣泛使用，擁有15.9億活躍用戶，其中75%的用戶為非美國人。
        </div>
        <div class="offer-btn">請求報價</div>
      </div>
      <div class="item">
        <img src="../assets/img-4.png" alt="">
        <div class="item-title">Google</div>
        <div class="item-text">
          全球最大的搜索引擎公司。谷歌是一家位於美國的跨國科技企業，業務包括互聯網搜索、雲計算、廣告技術等，同時開發並提供大量基於互聯網的產品與服務。
        </div>
        <div class="offer-btn">請求報價</div>
      </div>
    </div>
    <div class="web-box">
      <div class="title">歡迎來到我們的網站</div>
      <div class="web-list">
        <div class="web">
          <img src="../assets/img-5.png" alt="">
          <p>我們公司</p>
        </div>
        <div class="web">
          <img src="../assets/img-6.png" alt="">
          <p>質量控制</p>
        </div>
        <div class="web">
          <img src="../assets/img-7.png" alt="">
          <p>聯繫我們</p>
        </div>
      </div>
    </div>
    <div class="cooperation">
      <div class="title">全球戰略合作夥伴</div>
      <div class="subtitle">我們提供一站式海外數字營銷服務，根據您的業務制定專門的營銷解決方案。 </div>
      <div class="icon-box">
        <img src="../assets/icon-1.png" alt="">
        <img src="../assets/icon-2.png" alt="">
        <img src="../assets/icon-3.png" alt="">
        <img src="../assets/icon-4.png" alt="">
        <img src="../assets/icon-5.png" alt="">
        <img src="../assets/icon-6.png" alt="">
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data () {
    return {
     
    }
  },
  mounted () {
   
  },
  methods: {
   
  }
}
</script>


<style lang="less" scoped>
.img-1{
  width: 100%;
}
.communication{
  min-height: 281px;
  background: #1C539D;
  text-align: center;
  position: relative;
  display: block;
  overflow: hidden;
  .text-1{
    margin-top: 40px;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
  }
  .text-2{
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 16px;
  }
  .text-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    .input-text{
      width: 604px;
      height: 56px;
      background: #FFFFFF;
      outline: none;
      font-size:30px;
      padding: 0px 30px;
    }
    .subscribe{
      width: 160px;
      height: 56px;
      background: #38A3E1;
      text-align: center;
      line-height: 56px;
      font-size: 24px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
.link-box{
  display: flex;
  padding: 119px 359px;
  justify-content: space-between;
  .item{
    text-align: center;
    width: 362px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 362px;
    }
    .item-title{
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      margin-top: 23px;
    }
    .item-text{
      margin-top: 16px;
      font-size: 18px;
      font-weight: 500;
      color: #999999;
      min-height: 100px;
    }
    .offer-btn{
      width: 160px;
      height: 56px;
      background: #38A3E1;
      font-size: 24px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 56px;  
      margin-top: 20px;    
    }
  }
}
.web-box{
  // height: 531px;
  background: #1C539D;
  padding: 100px 499px;
  .title{
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
  }
  .web-list{
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    .web{
      img{
        width: 120px;
      }
      p{
        font-size: 32px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 40px;
      }
    }
  }
}
.cooperation{
  margin-top: 120px;
  text-align: center;
  .title{
    font-size: 40px;
    font-weight: 500;
  }
  .subtitle{
    font-size: 18px;
    font-weight: 500;
    color: #999999;
    margin-top: 16px;
  }
  .icon-box{
    padding: 79px 359px 119px 359px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      width: 359px;
    }

  }
}
</style>
